import { TransactionState, TransactionStateName } from '@frontend/transaction/types';

/**
 * Maps PuDo transaction list tabs to API `state` filters.
 * Shared by the list fetch and export so cancelled/completed stay in sync.
 */
export const getPudoTransactionStatesForTab = (activeTab: string): TransactionStateName[] | undefined => {
    switch (activeTab) {
        case 'all':
            return TransactionState.ALL_EXCEPT_DRAFT.map((state) => state.value);
        case 'draft':
            return [TransactionStateName.TRANSACTION_DRAFT];
        case 'active':
            return TransactionState.NOT_COMPLETED_CUSTOMER.map((state) => state.value);
        case 'completed':
            return [TransactionStateName.TRANSACTION_COMPLETED, TransactionStateName.TRANSACTION_COMPLETED_WITH_FAILURES];
        case 'cancelled':
            return [TransactionStateName.TRANSACTION_CANCELLED];
        case 'failed':
            return [TransactionStateName.TRANSACTION_FAILED];
        default:
            return undefined;
    }
};
